import script from "./ModalThree.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalThree.vue?vue&type=script&setup=true&lang=ts"

import "./ModalThree.vue?vue&type=style&index=0&id=6435265a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6435265a"]])

export default __exports__